import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuemeta from 'vue-meta'
import {store} from './store/store.js'
import vuetify from '@/plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

Vue.use(vuemeta)

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
